import React from "react";

import classnames from "classnames";

function LnbWrapper({ children, isLnbOpen, isLnbActive, hasGnb }) {
    return (
        <div
            className={classnames("Index boxMove clear", {
                boxMoveon: isLnbOpen && isLnbActive,
                boxMoveoff: !isLnbOpen || !isLnbActive,
                "not-mt-60 fullScreen": !hasGnb,
            })}
        >
            {children}
        </div>
    );
}

export default LnbWrapper;
